import {
  AutocompleteType,
  TextFieldType,
  CheckboxType,
} from "../../../utilis/component/CustomFormElement";
type InvestigationFormType = {
  cptItem: AutocompleteType;
  Rate: TextFieldType;
  Quantity: TextFieldType;
  amount: TextFieldType;
  patientShare: TextFieldType;
  outHouse: CheckboxType;
  approvalRequired: CheckboxType;
  IsPerfomed: CheckboxType;
  isExcluded:CheckboxType;
  Remark: TextFieldType;
  Reason: TextFieldType;
  insuranceCoverage:CheckboxType;
  discount: TextFieldType;
  discountType: TextFieldType;
};

export const investigationForm: InvestigationFormType = {
  cptItem: {
    element: "autocomplete",
    name: "cpt",
    fieldProps: { label: "CPT Item" },
    rules: { required: "cpt Required" },
    autocompleteProps: {
      getOptionLabel: (option) => option?.cptCode ? `(${option.cptCode}) ${option.cptName}` : "",
      isOptionEqualToValue: (option, value) => option.cptId == value.cptId,
    },
  },
  Rate: {
    element: "input",
    name: "Rate",
    fieldProps: { label: "Rate", type: "number" },
    rules: { required: "Rate required" },
  },
  Quantity: {
    element: "input",
    name: "Quantity",
    fieldProps: { label: "Quantity", type: "number" },
    rules: { required: "Quantity required" },
  },
  amount: {
    element: "input",
    name: "amount",
    fieldProps: { label: "amount", type: "number" },
    rules: { required: "Amount required" },
  },
  patientShare: {
    element: "input",
    name: "patientshare",
    fieldProps: { label: "Patient share", type: "number" },
    rules: { required: "Patient share required" },
  },
  outHouse: {
    element: "checkbox",
    name: "outHouse",
    rules: { required: false },
    fieldProps: { label: "Out house" },
  },
  approvalRequired: {
    element: "checkbox",
    name: "approvalRequired",
    rules: { required: false },
    fieldProps: { label: "Approval required " },
    checkboxProps: { label: "Approval required " },
  },
  IsPerfomed: {
    element: "checkbox",
    name: "IsPerfomed",
    rules: { required: false },
    fieldProps: { label: "IsPerfomed" },
  },
  isExcluded: {
    element: "checkbox",
    name: "isExcluded",
    rules: { required: false },
    fieldProps: { label: "Exclude" },
    checkboxProps: { label: "Exclude" },
  },
  Remark: {
    element: "input",
    name: "Remark",
    rules: { required: false },
    fieldProps: { label: "Remark" },
  },
  Reason: {
    element: "input",
    name: "Reason",
    rules: { required: false },
    fieldProps: { label: "Reason" },
  },
  insuranceCoverage: {
    element: "checkbox",
    name: "insuranceCoverage",
    rules: { required: false },
    fieldProps: { label: "Insurance coverage" },
    checkboxProps: { label: "Insurance coverage" },
  },
  discount: {
    element: "input",
    name: "discount",
    fieldProps: { label: "Discount", type: "number" },
    rules: { required: false },
  },
  discountType: {
    element: "input",
    name: "discountType",
    fieldProps: { label: "Discount Type" },
    rules: { required: false },
  },
};
